import { Component, Input, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { HeaderComponent } from 'projects/quoting-app/src/app/layout/header/header.component'
import { ProgressComponent } from 'projects/quoting-app/src/app/layout/progress/progress.component'
import { AirQuoteStore } from '../../air-quote.store'
import { GtmService } from 'projects/quoting-app/src/app/services/gtm.service'

@Component({
    selector: 'sf-air-quote-shell',
    imports: [RouterOutlet, HeaderComponent, ProgressComponent],
    templateUrl: './air-quote-shell.component.html',
    styleUrl: './air-quote-shell.component.scss',
})
export class AirQuoteShellComponent {
    airQuoteStore = inject(AirQuoteStore)
    gtm = inject(GtmService)

    @Input()
    set id(id: string) {
        if (!id) return

        if (Number(id) === 0) {
            this.airQuoteStore.initializeAirQuote()
        } else {
            this.gtm.trackEvent('quote_loaded', {
                quoteid: id,
            })
            this.airQuoteStore.loadExistingQuote(id)
        }
    }
}
